import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ServerSide from './ServerSide';
import ClientProvider from './client';
export default createDemo(import.meta.url, ServerSide, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/use-media-query/demos/server-side/ServerSide.tsx",
    "fileName": "ServerSide.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import mediaQuery from 'css-mediaquery';\nimport { ThemeProvider } from '@mui/material/styles';\nimport type { Theme } from '@mui/material/styles';\nimport useMediaQuery from '@mui/material/useMediaQuery';\n\nfunction MyComponent() {\n  const matches = useMediaQuery('(min-width:600px)');\n\n  return <span>{`(min-width:600px) matches: ${matches}`}</span>;\n}\n\nexport default function ServerSide() {\n  const ssrMatchMedia = (query: string) => ({\n    matches: mediaQuery.match(query, {\n      // The estimated CSS width of the browser.\n      width: 800,\n    }),\n  });\n\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider<Theme>\n      theme={{\n        components: {\n          MuiUseMediaQuery: {\n            // Change the default options of useMediaQuery\n            defaultProps: { ssrMatchMedia },\n          },\n        },\n      }}\n    >\n      <MyComponent />\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 34,
        "focusedLines": 12,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import mediaQuery from 'css-mediaquery';\nimport { ThemeProvider } from '@mui/material/styles';\nimport type { Theme } from '@mui/material/styles';\nimport useMediaQuery from '@mui/material/useMediaQuery';\n\nfunction MyComponent() {\n  const matches = useMediaQuery('(min-width:600px)');\n\n  return <span>{`(min-width:600px) matches: ${matches}`}</span>;\n}\n\nexport default function ServerSide() {\n  const ssrMatchMedia = (query: string) => ({\n    matches: mediaQuery.match(query, {\n      // The estimated CSS width of the browser.\n      width: 800,\n    }),\n  });\n\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider<Theme>\n      theme={{\n        components: {\n          MuiUseMediaQuery: {\n            // Change the default options of useMediaQuery\n            defaultProps: { ssrMatchMedia },\n          },\n        },\n      }}\n    >\n      <MyComponent />\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 21
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              "<",
              [
                "span",
                "pl-en",
                "Theme"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 22
            },
            [
              "      ",
              [
                "span",
                "pl-e",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 23
            },
            [
              "        ",
              [
                "span",
                "di-op",
                "components"
              ],
              ": {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 24
            },
            [
              "          ",
              [
                "span",
                "di-op",
                "MuiUseMediaQuery"
              ],
              ": {"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 25
            },
            [
              "            ",
              [
                "span",
                "pl-c",
                "// Change the default options of useMediaQuery"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 26
            },
            [
              "            defaultProps: { ",
              [
                "span",
                "pl-smi",
                "ssrMatchMedia"
              ],
              " },"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 27
            },
            "          },"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 28
            },
            "        },"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 29
            },
            [
              "      }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 30
            },
            "    >"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 31
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyComponent"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 32
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 34,
    "focusedLines": 12,
    "collapsible": true,
    "externals": [
      "css-mediaquery",
      "@mui/material/styles",
      "@mui/material/useMediaQuery"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
